export default __webpack_public_path__ + "static/media/LogoDrop.b5753d5a.svg";